import Sheet from 'shared/Sheet'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import { PropsWithChildren } from 'react'
import { IProjectStage } from '../../projectTypes.types'
import TwoListSelect from 'shared/TwoListSelect'
import { useAllCheckpointsState } from 'screens/Admin/ProjectCheckpoints/hooks/useAllCheckpointsState'
import searchUtils from 'utils/search'
import timeUtils from 'utils/time.utils'
import { IProjectCheckpoint } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import textUtils from 'utils/text.utils'
import durationUtils from '../../utils/durationUtils'

interface IProps {
  projectStage: Pick<IProjectStage, 'name' | 'checkpoints'>
  onChange: (val: any, name: string) => void
}

const ProjectStageSheet = (props: PropsWithChildren<IProps>) => {
  const { checkpointsState, checkpointsMap } = useAllCheckpointsState()

  const checkpointOptions = checkpointsState.items.map((c) => ({ title: c.name, value: c.id }))

  const getCheckpointDuration = (checkpointId: IProjectCheckpoint['id']) => {
    const days = timeUtils.sToDays(checkpointsMap[checkpointId]?.duration)
    return `${days} ` + textUtils.declineWordDependingOnCount(days, ['дней', 'день', 'дня'])
  }

  const handleSelectCheckpoints = (values: IProjectCheckpoint['id'][]) => {
    const addToSelected = values.map((v) => ({ projectCheckpointId: v, orderingIndex: 0 }))

    console.log(
      addToSelected,
      props.projectStage.checkpoints,
      [...addToSelected, ...props.projectStage.checkpoints].map((value, i) => ({ ...value, orderingIndex: i + 1 }))
    )
    props.onChange(
      [...addToSelected, ...props.projectStage.checkpoints].map((value, i) => ({ ...value, orderingIndex: i + 1 })),
      'checkpoints'
    )
  }

  const handleUnSelectCheckpoints = (values: IProjectCheckpoint['id'][]) => {
    const filtered = props.projectStage.checkpoints?.filter(
      (checkpoint) => !values.includes(checkpoint.projectCheckpointId)
    )
    props.onChange(filtered, 'checkpoints')
  }
  const duration = durationUtils.getProjectStageDuration(props.projectStage, checkpointsMap)
  const durationText = `${duration} ${textUtils.declineWordDependingOnCount(duration, ['дней', 'день', 'дня'])}`

  const handleChangeOrder = (values: IProjectCheckpoint['id'][]) => {
    props.onChange(
      values.map((v, i) => ({ projectCheckpointId: v, orderingIndex: i + 1 })),
      'checkpoints'
    )
  }

  return (
    <Sheet>
      <div className='flex-lines'>
        <div className='grid-form-2'>
          <TextField header='Наименование'>
            <TextInput value={props.projectStage.name} onChange={props.onChange} name='name' placeholder='Идея' />
          </TextField>
          <TextField header='Продолжительность'>
            <TextInput value={durationText} name='duration' onChange={() => {}} disabled />
          </TextField>
        </div>
        <div className='flex-lines'>
          <TwoListSelect
            options={checkpointOptions}
            selected={props.projectStage.checkpoints.map((c) => c.projectCheckpointId)}
            titleLeft={'Контрольные точки'}
            titleRight={'Все контрольные точки'}
            onSelect={handleSelectCheckpoints}
            onUnselect={handleUnSelectCheckpoints}
            onChangeOrder={handleChangeOrder}
            optionTitle={(option) => (
              <div>
                <p>{searchUtils.renderSearchResult(option.search)}</p>
                <p className='text--body-s text--secondary '>{getCheckpointDuration(option.value)}</p>
              </div>
            )}
          />
        </div>
      </div>
      <div className='form-footer'>{props.children}</div>
    </Sheet>
  )
}

export default ProjectStageSheet
